import TwitterAccessToken from './TwitterAccessToken';

export default TwitterAccessToken;

